import { NgModule, Component, Input, ChangeDetectionStrategy, OnChanges } from '@angular/core';

@Component({
    selector: 'marquee-row',
    templateUrl: 'marquee-row.template.html',
    styleUrls: ['marquee-row.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarqueeRow {
    @Input() item: any;
    @Input() disable: boolean = false;
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/marquee/marquee-row/marquee-row.component.ts